import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import SearchIcon from "@mui/icons-material/Search";
import { TableSortLabel, SvgIcon, Menu } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import { Button, Grid, Typography } from "@material-ui/core";
import { useHistory, useRouteMatch } from "react-router-dom";
import {
  getDateTime,
  maskMobile,
  searchFilter,
  handleSort,
  getDate,
  getTime,
} from "../utils/varialbles";
import toast from "react-hot-toast";
import http from "../services/httpService";
import SearchBar from "material-ui-search-bar";
//import Filter from '../components/filerComponent';
// comment the above one replace with below 1 --step1
import useFilter from "../components/filterComponent";

import { ReactComponent as FilterLogo } from "../images/filter.svg";
import filterData from "../components/filterCriteria";

const columns = [
  { label: "Mobile Number", id: "Mobile", minWidth: 150 },
  { label: "First Name", id: "custfirstname", minWidth: 150 },
  { label: "Last Name", id: "custlastname", minWidth: 150 },
  { label: "Email ID", id: "email", minWidth: 150 },
  { label: "User Id", id: "userid", minWidth: 100 },
  // {
  //   label: "Preferred Language",
  //   id: "Language",
  //   minWidth: 150,
  //   filter: true,
  //   filterType: "dropDown",
  //   conditions: [{ text: "Equal", value: "eq" }],
  //   options: "data",
  //   multi: true,
  // },
  {
    label: "Date Time",
    id: "Time",
    minWidth: 200,
    format: "FullDate",
    filter: true,
    filterType: "date",
    conditions: [
      { text: "less than", value: "lte" },
      { text: "greater than", value: "gte" },
    ],
  },
  { label: "Executive", id: "exec", minWidth: 150 },
  { label: "Status", id: "status", minWidth: 150, align: "left" },
  { label: "Call", id: "detailsButton", minWidth: 150, align: "left" },
];

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
});

function InvestorCallRequest() {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState([]);
  const [searched, setSearched] = React.useState("");
  const [orignalRows, setOriginalRows] = React.useState([]);
  const [columnsUpdate, setColumnsUpdate] = useState([]);
  const [orderBy, setOrderBy] = React.useState("cust__createddt");
  const [order, setOrder] = React.useState("asc");
  const [anchorEl, setAnchorEl] = React.useState(null);
  // (Boolean(anchorEl));
  // const isMenuOpen = Boolean(anchorEl);
  const isMenuOpen = anchorEl;
  const form = {
    Language: [],
    Time__condition: "lte",
    Time: "",
  };
  const [formObject, setFormObject] = React.useState(form);
  const clearFilter = () => {
    setFormObject(form);
    setRows(orignalRows);
  };
  const applyFilter = (e) => {
    let tempObject = { ...formObject };
    let tempORows = [...orignalRows];
    let filter = filterData(tempObject, tempORows, columns);
    setRows(filter);
    setPage(0);
  };
  const openFilter = (e) => {
    // let currentTarget = e.currentTarget;
    // setAnchorEl(currentTarget);
    setAnchorEl(true);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleChange = (e) => {
    setFormObject({
      ...formObject,
      [e.target.name]: e.target.value,
    });
  };
  const requestSearch = (searchedVal) => {
    setSearched(searchedVal);
    setPage(0);
  };

  const cancelSearch = () => {
    setSearched("");
    let abc = "";
    getData(abc);
  };
  const requestSearching = () => {
    if (searched === undefined || searched.length < 4) {
      toast.error("Please Enter more than 3 characters to search");
    } else {
      getData(searched);
    }
  };

  let history = useHistory();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleRequestSort = (e, property, format) => {
    let isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let tempRows = [...rows];
    let finalRows = handleSort(property, format, tempRows, isAsc);
    setRows(finalRows);
    setPage(0);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleCall = (e, row) => {
    if (row && row.cust_id && row.Request_ID && !row.webcall) {
      http
        .get(
          "/callrequest?cust_id=" +
            row.cust_id +
            "&request_id=" +
            row.Request_ID +
            "&location=I"
        )
        .then((res) => {
          if (res.data.Data && res.data.Data !== "Exception") {
            toast.success("Call request placed successfully!");
          } else {
            toast.error("Call request Failed!");
          }
        })
        .catch((err) => {
          toast.error("Call request Failed!");
        });
    } else if (row && row.Request_ID && row.webcall) {
      http
        .get(
          "/callrequest?cust_id=" +
            row.cust_id +
            "&request_id=" +
            row.Request_ID +
            "&location=I"
        )
        .then((res) => {
          if (res.data.statusCode === 0) {
            toast.success("Call request placed successfully!");
          } else if (res.data.statusCode === 2 && res.data.Data) {
            toast.error(res.data.Data);
          } else {
            toast.error("Call request Failed!");
          }
        })
        .catch((err) => {
          toast.error("Call request Failed!");
        });
    }
  };

  //for webcall
  //  .get("/callrequests_webcall?request_id=" + row.Request_ID)

  // added the below line --step2
  const [Filter, filterString, passFilters, passData] = useFilter();

  const [totalRowCount, setTotalRowCount] = React.useState(0);
  const getPaginationURL = (url, newQuery) => {
    const query = newQuery === "" ? newQuery : searched;
    if (query) {
      return `${url}?page=${
        page + 1
      }&rowsPerPage=${rowsPerPage}&search=${query}`;
    } else {
      return `${url}?page=${page + 1}&rowsPerPage=${rowsPerPage}`;
    }
  };

  const getData = (newQuery) => {
    toast.loading("Please wait...");
    const baseURL = "/invcallrequests";
    setOriginalRows([]);
    setRows([]);
    http
      .get(getPaginationURL(baseURL, newQuery) + filterString)
      .then((response) => {
        toast.dismiss();
        if (
          response &&
          response.data &&
          response.data.Data &&
          Array.isArray(response.data.Data) &&
          response.data.Data.length > 0
        ) {
          // ('ooooooo');
          setOriginalRows(response.data.Data);
          setRows(response.data.Data);
          setTotalRowCount(response.data.totalRowCount);
          if (!filterString) passFilters(response.data.filter || []); // added if condition step4
        }
      });
  };

  useEffect(() => {
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("internalFilter");
    localStorage.removeItem("selectedfiltersdata");
    localStorage.removeItem("selectedinvestorfiltersdata");
    getData();
    updateColumns();
  }, [page, rowsPerPage, filterString]); //added filterString into this array step5

  useEffect(() => {
    // ("totalRowCount Changed");
    // alert(searched);
  }, [totalRowCount, rows]);

  const updateColumns = () => {
    if (
      localStorage.getItem("empRole") === "MF Manager" ||
      localStorage.getItem("empRole") === "MF Executive" ||
      localStorage.getItem("empRole") === "Franchise"
    ) {
      setColumnsUpdate([
        { label: "Mobile Number", id: "Mobile", minWidth: 150 },
        { label: "First Name", id: "custfirstname", minWidth: 150 },
        { label: "Last Name", id: "custlastname", minWidth: 150 },
        { label: "Email ID", id: "email", minWidth: 150 },

        // {
        //   label: "Preferred Language",
        //   id: "Language",
        //   minWidth: 150,
        //   filter: true,
        //   filterType: "dropDown",
        //   conditions: [{ text: "Equal", value: "eq" }],
        //   options: "data",
        //   multi: true,
        // },
        {
          label: "Date Time",
          id: "Time",
          minWidth: 200,
          format: "FullDate",
          filter: true,
          filterType: "date",
          conditions: [
            { text: "less than", value: "lte" },
            { text: "greater than", value: "gte" },
          ],
        },
        { label: "User Id", id: "userid", minWidth: 100 },
        { label: "Executive", id: "exec", minWidth: 150 },
        { label: "Status", id: "status", minWidth: 150, align: "left" },        
        { label: "Call", id: "detailsButton", minWidth: 150, align: "left" },
      ]);
    } else {
      setColumnsUpdate(columns);
    }
  };
  return (
    <div className={classes.root}>
      {/* <Grid container style={{ marginTop: "10px" }}>
        <Grid
          item
          xs={false}
          sm={12}
          md={12}
          style={{ marginTop: 30 }}
          align="center"
        >
          <Typography color="textPrimary" variant="h5">
            Prospect Call Requests
          </Typography>
        </Grid>
      </Grid> */}
      <Paper>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          style={{ paddingInline: 5 }}
        >
          <Grid item>
            <Grid container justifyContent="space-between" alignItems="center">
              <SearchBar
                value={searched}
                onChange={(searchVal) => requestSearch(searchVal)}
                onCancelSearch={(searchVal) => cancelSearch(searchVal)}
                onRequestSearch={requestSearching}
                style={{ height: "auto", padding: "5px 0" }}
              />

              <Button
                variant="outlined"
                color="primary"
                style={{
                  marginLeft: "10px",
                  borderRadius: "20px",
                  height: "35px",
                }}
                onClick={requestSearching}
                disabled={!searched}
              >
                Search
              </Button>
            </Grid>
          </Grid>
          <Grid item style={{ paddingTop: 10 }}>
            <TablePagination
              rowsPerPageOptions={[10, 50, 100, 500]}
              component="div"
              count={totalRowCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Grid>
          <Grid item>
            <Grid container alignContent="center">
              <span>Filter</span>
              <SvgIcon
                style={{ cursor: "pointer" }}
                onClick={openFilter}
                title={"filter"}
              >
                <FilterLogo />
              </SvgIcon>
            </Grid>
            <Menu
              anchorEl={anchorEl}
              id={"Filtermenu"}
              keepMounted
              open={isMenuOpen}
              onClose={handleMenuClose}
              getContentAnchorEl={null}
              transformOrigin={{ horizontal: "rigth", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "top" }}
              style={{
                top: "260px",
                left: "0px",
              }}
            >
              {/* <Filter columns={columns} applyFilter={applyFilter} orignalRows={orignalRows}
                       handleChange={handleChange} formObject={formObject} clearFilter={clearFilter}/> */}

              {/* comment the above one replace with below 1 --step6 */}
              <Filter data={passData} onClick={setAnchorEl} />
            </Menu>
          </Grid>
        </Grid>

        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {columnsUpdate.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={(e) =>
                        handleRequestSort(e, column.id, column.format)
                      }
                    >
                      {column.label}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length !== 0 ? (
                <>
                  {rows.map((row, index) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index + "a"}
                      >
                        {columnsUpdate.map((column, index) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              key={index + column.id}
                              align={column.align}
                            >
                              {column.format && typeof value === "number" ? (
                                column.format(value)
                              ) : column.id === "detailsButton" ? (
                                <Button
                                  variant="contained"
                                  color="primary"
                                  style={{ borderRadius: 20 }}
                                  onClick={(e) => handleCall(e, row)}
                                >
                                  {row["webcall"]
                                    ? "Web " + column.label
                                    : column.label}
                                </Button>
                              ) : column.format === "FullDate" ? (
                                getDate(value) + " - " + getTime(value)
                              ) : column.id === "Mobile" ? (
                                value
                              ) : value !== null ? (
                                value
                              ) : (
                                "N/A"
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </>
              ) : (
                <TableCell
                  colspan="7"
                  style={{ "text-align": "center", margin: "10px 0px" }}
                >
                  Records Not Available
                </TableCell>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
}
export default InvestorCallRequest;
